import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
  GeneralResModel,
  PmsBreedModel,
  PmsClientModel,
  PmsPetColorModel,
  PmsSpeciesModel,
} from "src/app/_models";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class PetPatientService {
  private baseURL = `${environment.apiUrl}`;
  private apiPATH = this.baseURL + `PetPatient/`;

  constructor(private _httpClient: HttpClient) {}

  // PET PATIENT APIs START
  getBreeds() {
    return this._httpClient.get<GeneralResModel<PmsBreedModel[]>>(
      `${this.apiPATH}GetPmsBreeds`
    );
  }

  getSpecies() {
    return this._httpClient.get<GeneralResModel<PmsSpeciesModel[]>>(
      `${this.apiPATH}GetPmsSpeciess`
    );
  }

  getPetColors() {
    return this._httpClient.get<GeneralResModel<PmsPetColorModel[]>>(
      `${this.apiPATH}GetPmsPetColors`
    );
  }
  // PET PATIENT APIs END

  // PET OWNER APIs START
  getPmsClientsByOrgId(orgid: number) {
    return this._httpClient.get<GeneralResModel<PmsClientModel[]>>(
      `${this.apiPATH}GetPmsClientsByOrgId/${orgid}`
    );
  }

  getPmsClients() {
    return this._httpClient.get<GeneralResModel<PmsClientModel[]>>(
      `${this.apiPATH}GetPmsClients`
    );
  }

  GetPmsClientById(clientId: number) {
    return this._httpClient.get<GeneralResModel<PmsClientModel>>(
      `${this.apiPATH}GetPmsClientById/${clientId}`
    );
  }

  getClientAutoComplete(
    filter: string,
    type: string,
    status: string,
    orderId: number
  ) {
    return this._httpClient.get<GeneralResModel<PmsClientModel[]>>(
      `${this.apiPATH}GetClientAutoComplete/${filter}/${type}/${status}/${orderId}`
    );
  }

  getClientAutoCompleteByOrgOwner(
    filter: string,
    type: string,
    status: string,
    orgId: number
  ) {
    return this._httpClient.get<GeneralResModel<PmsClientModel[]>>(
      `${this.apiPATH}GetClientAutoComplete/${filter}/${type}/${status}/${orgId}`
    );
  }

  createPmsClient(request: PmsClientModel) {
    return this._httpClient.post<GeneralResModel<PmsClientModel>>(
      `${this.apiPATH}CreatePmsClient`,
      request
    );
  }

  updatePmsClient(request: PmsClientModel) {
    return this._httpClient.post<GeneralResModel<PmsClientModel>>(
      `${this.apiPATH}UpdatePmsClient`,
      request
    );
  }

  deletePmsClient(request: PmsClientModel) {
    return this._httpClient.post<GeneralResModel<string>>(
      `${this.apiPATH}DeletePmsClient`,
      request
    );
  }
  // PET OWNER APIs END
}
